import "../../index41.css";
import { jsxs as g, Fragment as x, jsx as b } from "react/jsx-runtime";
import { useContext as _, useMemo as v } from "react";
import { i as N, a as D } from "../../type-BFTbooL7.js";
import { _ as L } from "../../cs-piwRuCFZ.js";
import O from "../../contexts/language.js";
import { h as T } from "../../common-UUpiO33D.js";
import { DEFAULT_INVALID_TEXT as h } from "../../utils/constants.js";
const F = "_number-output_1blvi_1", j = {
  numberOutput: F
};
function S(p) {
  const {
    className: f,
    invalidText: r = h,
    separatorHidden: e,
    compact: o,
    currency: i,
    value: t,
    tooltip: u,
    unit: n,
    prefix: m,
    suffix: a,
    maximumFractionDigits: s = 1
  } = p, { currentLanguage: c } = _(O), l = v(
    () => {
      if (N(t))
        return r;
      const d = T(
        t,
        {
          currency: i,
          compact: o,
          separatorHidden: e,
          maximumFractionDigits: s,
          unit: n,
          language: c
        }
      );
      return /* @__PURE__ */ g(x, { children: [
        m,
        d,
        a
      ] });
    },
    [
      r,
      t,
      o,
      e,
      i,
      n,
      s,
      m,
      c,
      a
    ]
  );
  return /* @__PURE__ */ b(
    "div",
    {
      className: L(j.numberOutput, f),
      title: D(u) ? String(u) : void 0,
      children: l
    }
  );
}
export {
  S as default
};
